export const getMinhaContaUrl = (): string => {
  const minhaContaUrl =
    window.location.hostname === 'localhost'
      ? `${window.location.protocol}//localhost:3050`
      : `${window.location.origin}/minha-conta/`;
  return `${minhaContaUrl}?referrer=${document.title}&referrer_uri=${window.location.href}`;
};

export const getTenantByUrl = () => {
  const hostname = window.location.hostname;

  const tenant =
    hostname.indexOf('.') > -1
      ? hostname.slice(0, hostname.indexOf('.'))
      : hostname;

  return tenant;
};

export const getFieldOnSearchParams = (
  searchParam: string,
  field: string
): string | null => {
  const searchParams = new URLSearchParams(searchParam);
  return searchParams.get(field);
};

export const populateObjectFromSearchParams = <
  T extends Record<string, string>
>(
  searchParam: string,
  initialValues: T
): T => {
  const searchParams = new URLSearchParams(searchParam);

  return Object.fromEntries(
    Object.keys(initialValues).map(key => [
      key,
      searchParams.get(key) ?? initialValues[key]
    ])
  ) as T;
};
